export default __webpack_public_path__ + "static/media/logo.dcc63f57.png";